export default __webpack_public_path__ + "static/costume_f-16b32361c561fc8cab0ecd0ad3009a92.png";